import { render, staticRenderFns } from "./assemblyForOrder.vue?vue&type=template&id=7836021c&scoped=true"
import script from "./assemblyForOrder.vue?vue&type=script&lang=js"
export * from "./assemblyForOrder.vue?vue&type=script&lang=js"
import style0 from "./assemblyForOrder.vue?vue&type=style&index=0&id=7836021c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836021c",
  null
  
)

export default component.exports